import styled from 'styled-components'

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const SubHeadingContainer = styled.div`
  > div:first-of-type {
    border-bottom: 1px solid var(--color-issabeline-grey);
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
`

export const SectionContainer = styled(FlexContainer)`
  justify-content: space-between !important;
`
export const FormContainer = styled.div`
  padding: 30px 20px;
  width: 100%;
  min-width: 800px;
`

export const Heading = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: var(--color-charcoal);
  margin-bottom: 6px;
`

export const SubHeading = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: var(--color-dark-gray);
  margin-bottom: 0px;
`
